import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, timeout: 90_000 }); // 90s for long scraper requests

// Clerk session-token getter, registered by AuthProvider once Clerk loads.
let tokenGetter = null;
export function setApiTokenGetter(fn) {
  tokenGetter = fn;
}
export async function getApiToken() {
  if (!tokenGetter) return "";
  try { return (await tokenGetter()) || ""; } catch { return ""; }
}

api.interceptors.request.use(async (config) => {
  if (tokenGetter) {
    try {
      const token = await tokenGetter();
      if (token) config.headers.Authorization = `Bearer ${token}`;
    } catch {
      /* not signed in yet */
    }
  }
  return config;
});

// Retry once on network / timeout errors (scraper requests can be flaky)
api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const cfg = err?.config;
    const isNetwork = !err?.response && (err?.code === "ECONNABORTED" || err?.message?.includes("Network") || err?.message?.includes("timeout"));
    if (isNetwork && cfg && !cfg._retried) {
      cfg._retried = true;
      await new Promise((r) => setTimeout(r, 2000));
      return api(cfg);
    }
    return Promise.reject(err);
  }
);

export function apiErr(e, fallback = "Terjadi kesalahan. Coba lagi.") {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export default api;
